<template>
    <div class="articleEdit">
        <div class="uEditorBoxbgc box-shadow bgc">
            <ContributeUeditor ref="contributeUeditor" placeholder="请输入正文内容" @getUEditorContent="getUEditorContent" />
        </div>
        <!-- 发布的内容 -->
        <div class="issueContent padding-20 bgc box-shadow">
            <div class="articleForm form">
                <el-form :model="articleData" :rules="rules" ref="articleData" label-width="110px" class="demo-item" label-position="left" size="mini">
                    <el-form-item label="导读" class="guidance">
                        <el-button @click="getGuidanceTips">生成导读</el-button>
                        <el-input type="textarea" autosize maxlength="150" placeholder="请输入导读" show-word-limit v-model="articleData.guidance"></el-input>
                    </el-form-item>
                    <el-form-item label="封面" class="upload-image">
                        <upload class="headImage" :imgRule="imgRule" ref="coverfile" :uploadType="uploadType" @setImage="getImageUrl"></upload>
                        <p class="tips">建议尺寸750*420px，JPG、PNG格式， 图片小于5M。</p>
                    </el-form-item>
                    <el-form-item label="栏目">
                        <el-select v-model="articleData.column" @change="columnChange">
                            <el-option v-for="(item, index) in columnList" :key="index" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item class="ycsm" label="原创">
                        <el-checkbox label="" v-model="articleData.articletype"></el-checkbox>
                        <p class="sm">声明原创要求：正文字数>300，且原创内容多于引用内容。 抄袭 、洗稿等滥用原创行为将有处罚，详见<span>《声明原创须知》</span></p>
                    </el-form-item>
                    <el-form-item label="来源" v-show="!articleData.articletype">
                        <el-input v-model.trim="articleData.articlezzsource" placeholder="转载必填" ></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="btnBox bgc box-shadow">
            <el-button type="primary" @click="submitForm('articleData', 0)" v-if="articleData.status !== 1">发布</el-button>
            <el-button type="warning" @click="submitForm('articleData', 1)" v-if="!articleData.status || articleData.status == 0 ">存至草稿</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
    </div >
</template>
<script>
import Upload from 'base/upload/upload'
import UEditor from 'base/uEditor/uEditor'
import {saveOrUpdateArticle, getArticleInfoByCon} from '@/api/imageText'
import {formatCheckList, formatCheckView, formatFileInfo} from '@/common/js/tools'
import {mapGetters, mapActions} from 'vuex'
import ShalfSetting from 'base/promotionMsg/shalfSetting'
import $ from 'jquery'
import ContributeUeditor from '@/base/uEditor/contributeUeditor.vue'
export default {
    name: 'articleEdit',
    data() {
        // 检查图文封面
        let validateCoverPicture = (rule, value, callback) => {
            if (!value.furl) {
                callback(new Error('请选择封面'))
            } else {
                callback()
            }
        }
        return {
            alertData: [
                {title: ' 请您遵守国家相关规定，切勿上传低俗色情、暴力恐怖、谣言诈骗、侵权盗版等相关内容，我们保有依据国家规定及平台规则进行处理的权利。'}
            ],
            time: new Date().getTime(),
            innerid: this.$route.query.innerid ? this.$route.query.innerid : '',
            articleData: {
                innerid: this.$route.query.innerid ? this.$route.query.innerid : '', // id
                articlename: '', // 图文名称
                despfee: '', // 图文详情
                articletype: false,  // 文章类型：1原创 2转载
                isdraft: '',    // 是否草稿 0 否 1 是
                articlezzsource:'', //转载来源
                column: 'pevc', // 栏目
                columnname: '创投', // 栏目名
                guidance: '', // 导读
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            rules: {
                articlename: [
                    {required: true, message: '请输入标题名称', trigger: 'blur'},
                    {min: 1, max: 90, message: '长度在 1 到 90 个字符', trigger: 'blur'}
                ],
                despfee: [
                    {required: true, message: '请输入正文内容', trigger: 'blur'}
                ],
                //coverPicture: [
                //    {validator: validateCoverPicture, trigger: 'blur'}
                //]
                // articlezzsource:[
                //     {required: true, message: '请输入转载来源', trigger: 'blur'}
                // ]
            },
            columnList: [
                {label: '创投', value: 'pevc'},
                {label: 'IPO', value: 'ss'},
		{label: '行业', value: 'hyqs'},
                {label: '公司', value: 'gsjj'},
                {label: '人物', value: 'rwdh'},
                {label: '职场', value: 'cycx'},
                {label: '财经', value: 'cjyw'},
                {label: '政策', value: 'hgzc'}
            ],
            imgRule: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg',
                size: 2,
                width: 100,
                height: 100,
                btnName: '选择文件',
                nottype: true
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE',
                attid: '',
                url: ''
            }
        }
    },
    created() {
    },
    mounted() {
        if (this.articleData.innerid) {
            this.getArticleInfoByConId(this.articleData.innerid)
        }
    },
    methods: {
        handleOpenGallery() {
            this.$refs.gallery.openDialog(this.item)
        },
        // 生成导读提示
        getGuidanceTips() {
            if (this.articleData.despfee) {
                if (this.articleData.guidance) {
                    this.$confirm('是否覆盖当前导读内容?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        // type: 'warning'
                    }).then(() => {
                        this.getGuidance()
                    }).catch(() => {        
                    })
                } else {
                    this.getGuidance()
                }
            } else {
                this.$message.warning('请先输入正文内容')
            }
        },
        getGuidance() {
            var reg = /<[^>]+>/gi
            this.articleData.guidance = this.articleData.despfee.replace(reg, '').replace('&nbsp;', '').slice(0, 150)
        },
        getUEditorContent(data) {
            this.articleData.articlename = data.title
            if (data.detail && data.detail !== '<p><span class="ue_zj_placeholder">请输入正文内容</span></p>' && data.detail !== '<span class="ue_zj_placeholder">请输入正文内容</span>') {
                this.articleData.despfee = data.detail
            }
        },
        columnChange(value) {
            this.columnList.some(item => {
                if (item.value === value) {
                    this.articleData.columnname = item.label
                    return true
                }
            })
        },
        submitForm(formName, isdraft) {
            if (!this.articleData.articlename) {
                this.$message.error('请输入标题')
                return false
            }
            if (!this.articleData.despfee) {
                this.$message.error('请输入投稿内容')
                return false
            }
            if(!this.articleData.articletype && !this.articleData.articlezzsource){
                this.$message.error('请输入转载来源')
                return false
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$confirm('请确认您的输入信息是否完整正确？', '提交内容', {
                            cancelButtonText: '取消',
                            confirmButtonText: '确定',
                            closeOnClickModal: false
                    }).then(() => {
                            let data = JSON.parse(JSON.stringify(this.articleData))

                            if (data.articletype) {
                                if (data.despfee.length < 300) {
                                    this.$message.error('声明原创要求：正文字数>300')
                                    return false
                                }
                            }

                            data.innerid = this.$route.query.innerid
                            delete data.coverPicture.type
                            data.coverPicture = JSON.stringify(data.coverPicture)
                            data.articletype = data.articletype ? 1 : 2
                            data.isdraft = isdraft
                            this.updateArticleMsg(data)
                    }).catch(() => {})
                } else {
                    this.$message.error('请完善您的数据！')
                    return false
                }
            })
        },
        updateArticleMsg(obj) {
            this.setLoading(true)
            saveOrUpdateArticle({
                data: obj,
                success: data => {
                    if (data.code === '000') {
                        this.setLoading(false)
                        this.$message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.$router.push({name: 'ArticleTGList'})
                    } else {
                        this.setLoading(false)
                        this.$message.error('保存失败')
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        cancel() {
            this.$router.push({name: 'ArticleTGList'})
        },
        getImageUrl(file) {
            this.articleData.coverPicture = file
            this.time = new Date().getTime()
        },
        // 获取单个图文数据
        getArticleInfoByConId(innerid) {
            this.setLoading(true)
            getArticleInfoByCon({
                data: {innerid},
                success: data => {

                    this.setLoading(false)
                    this.articleData = data.data
                    this.articleData.coverPicture = JSON.parse(this.articleData.coverPicture)
                    this.$refs.coverfile.setImage(this.articleData.coverPicture.furl)
                    this.$refs.contributeUeditor.init(this.articleData.despfee, this.articleData.articlename)
                    this.articleData.articletype = this.articleData.articletype == 1
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Upload,
        UEditor,
        ShalfSetting,
        ContributeUeditor
    },
    watch: {
    },
    computed: {
        ...mapGetters([
            'loading',
            'user',
            'permission'
        ])
    }
}
</script>
<style lang="scss">
@import "~common/scss/mixin";
@import "~common/scss/base";
.articleEdit{
    height: 100%;
    overflow-y: auto;
    .ue_btn {
        display: none;
    }
    .btnlist {
        margin-top: 20px;
    }
    // .uEditor .edui-default .edui-editor, .uEditor .edui-default .edui-editor-iframeholder {
    //     height: 356px;
    // }
    .ycsm {
        .el-checkbox,
        .sm {
            float: left;
            margin-right: 0;
        }
        .sm {
            margin-left: 10px;
            width: 383px;
            font-size: 14px;
            color: #909399;
            span {
                font-size: 14px;
                color: #409EFF;
                cursor: pointer;
            }
        }
    }
    .el-alert{
        height: 44px;
    }
    .issueContent{
        margin-top: 20px;
        .title{
            color: #409EFF;
            font-size: 16px;
            margin-bottom: 20px;
            span{
                color: #303133;
                font-weight: 700;
                position: relative;
                top: 2px;
            }
        }
        .articleForm{
            margin-top: 0px;
            width: 925px;
            .upload-image{                
                .el-form-item__content{
                    @include flexBox('');
                    .tips{
                        margin-left: 50px;
                        color: #C0C4CC;
                    }
                }
            }
            .guidance {
                .el-button {
                    margin-bottom: 5px;
                    width: 76px;
                    height: 32px;
                    min-width: 76px;
                    color: #409EFF;
                    border-color: #c6e2ff;
                    background-color: #ecf5ff;
                }
                .el-textarea {
                    // height: 48px;
                    .el-textarea__inner {
                        border-radius: 0;
                        border: none;
                        border-bottom: 1px solid #EEEEEE;
                        padding: 15px 60px 15px 0;
                        font-size: 14px;
                        height: 48px;
                        resize: none;
                    }
                    .el-input__count {
                        font-size: 14px;
                        bottom: 13px;
                    }
                }
            }
            .headImage .avatar-uploader{
                box-sizing: border-box;
                width: 280px;
                height: 157px;
            }
            .original{
                color: #606266;
                font-size: 12px;
            }
            .radioTips{
                padding-left: 24px;
                color: #606266;
            }
            .showWay{
                .el-radio{
                    margin-right: 50px;
                }
            }
            .commodityGroup{
                .refresh{
                    color: #409EFF;
                    margin-left: 18px;
                    cursor: pointer;
                }
                .goCommodityGroup{
                    margin-left: 22px;
                    cursor: pointer;
                    color: #409EFF;
                }
                .groupTips{
                    font-size: 14px;
                    color: #909399;
                }
                .el-select{
                    width: 368px;
                }
            }
            .onlineWay{
                .el-form-item__label::after{
                    content: "*";
                    color: #F56C6C;
                    margin-left: 4px;
                }
            }
            .el-radio__input.is-checked+.el-radio__label{
                color: #303133;
            }
        }
    }
    .btnBox {
        margin-top: 20px;
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
